import type {
    SearchPrefetchSessionSummary,
    SearchPrefetchTracker,
} from "./search-prefetch-instrumentation";

export function hasSearchPrefetchActivity(
    summary: SearchPrefetchSessionSummary,
) {
    const hasObservations = Object.values(summary.bySource).some((source) =>
        Object.values(source).some((count) => count > 0),
    );
    return (
        hasObservations ||
        summary.attemptsDropped > 0 ||
        summary.attemptTransitionsDropped > 0 ||
        summary.searchKeysDropped > 0 ||
        summary.adoptionsDropped > 0
    );
}

export function registerSearchPrefetchPageLifecycle(
    target: Window,
    tracker: SearchPrefetchTracker,
    capture: (summary: SearchPrefetchSessionSummary) => void,
) {
    const handlePageHide = (event: PageTransitionEvent) => {
        capture(tracker.pageHideSummary(event.persisted === true));
    };
    const handlePageShow = (event: PageTransitionEvent) => {
        tracker.pageShow(event.persisted === true);
    };
    target.addEventListener("pagehide", handlePageHide, { capture: true });
    target.addEventListener("pageshow", handlePageShow);
    return () => {
        target.removeEventListener("pagehide", handlePageHide, {
            capture: true,
        });
        target.removeEventListener("pageshow", handlePageShow);
    };
}

const lifecycleInstalledKey = Symbol.for(
    "wags.search-prefetch-page-lifecycle-installed",
);

export function installSearchPrefetchPageLifecycle(
    target: Window,
    tracker: SearchPrefetchTracker,
    capture: (summary: SearchPrefetchSessionSummary) => void,
) {
    if (Reflect.get(target, lifecycleInstalledKey) === true) return;
    Reflect.set(target, lifecycleInstalledKey, true);
    registerSearchPrefetchPageLifecycle(target, tracker, capture);
}
